import { render, staticRenderFns } from "./ProductACVGrades.vue?vue&type=template&id=2fd46d23&scoped=true&"
import script from "./ProductACVGrades.vue?vue&type=script&lang=js&"
export * from "./ProductACVGrades.vue?vue&type=script&lang=js&"
import style0 from "./ProductACVGrades.vue?vue&type=style&index=0&id=2fd46d23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd46d23",
  null
  
)

export default component.exports